import Image from 'next/image';
import logoImg from '../../../public/images/Value-Added-ResellerTonoGris.png';

export default function LogoZOHO() {
  return (
    <div className="flex items-center justify-center h-16 w-64"> 
      <Image src={logoImg} alt="Logo ZOHO" className="h-full w-full object-contain" />
    </div>
  )
}